import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {
    isLoading = new BehaviorSubject<boolean>(false);
    show() {
        this.isLoading.next(true);
        console.log("[LoaderService.show]> ", this.isLoading);
    }
    hide() {
        this.isLoading.next(false);
    }
}